export default __webpack_public_path__ + "static/media/Buy.401fcded.svg";